export default "__VITE_ASSET__obxzs0Q9__"